import type { GuideQuestDefinition, GuideQuestObjectiveKind } from "@yjsgames/guide-quest";
import guideQuestsJson from "./generated/guideQuests.json";
import { REWARD_BUNDLES } from "./rewardData.js";

const OBJECTIVE_KINDS = new Set<GuideQuestObjectiveKind>([
  "chapterReached",
  "tabEntered",
  "modulePlaced",
  "upgradeBought",
  "actionCompleted",
  "rewardClaimed",
]);

export type RawGuideQuestRow = (typeof guideQuestsJson)[number];

export function parseGuideQuestDefinitions(
  rows: readonly RawGuideQuestRow[],
  rewardBundles: Record<string, unknown> = REWARD_BUNDLES,
): GuideQuestDefinition[] {
  return rows.map((row) => {
    if (!OBJECTIVE_KINDS.has(row.objectiveKind as GuideQuestObjectiveKind)) {
      throw new Error(`[guideQuestData] unknown objectiveKind: ${row.objectiveKind}`);
    }
    if (!rewardBundles[row.rewardBundle]) {
      throw new Error(
        `[guideQuestData] missing reward bundle '${row.rewardBundle}' for ${row.questId}`,
      );
    }
    return {
      questId: row.questId,
      order: row.order,
      enabled: row.enabled,
      titleKey: row.titleKey,
      descriptionKey: row.descriptionKey,
      objectiveKind: row.objectiveKind as GuideQuestObjectiveKind,
      objectiveTarget: row.objectiveTarget || "any",
      targetCount: Math.max(1, Math.floor(row.targetCount)),
      rewardBundleId: row.rewardBundle,
    };
  });
}

export const GUIDE_QUEST_ENABLED = true;

export const GUIDE_QUEST_DEFINITIONS: readonly GuideQuestDefinition[] =
  GUIDE_QUEST_ENABLED ? parseGuideQuestDefinitions(guideQuestsJson) : [];
